import { zeytalAPIBaseUrl } from "@zeytal/kit/api";

let apiBaseUrl = zeytalAPIBaseUrl;

export const getZeytalApiBaseUrl = () => {
  if (process.env.ZEYTAL_API_BASE) {
    apiBaseUrl = process.env.ZEYTAL_API_BASE;
  }
  return apiBaseUrl;
};
